import React, { useState, useEffect } from 'react';
import './HomeCommunityCallToAction.css';
import communityIllustration from '../assets/Book Events/group.png';
import whatsappIcon from '../assets/images/whatsapp.png';
import { getLanguage } from 'react-switch-lang';
import en from '../en.json';
import ma from '../ma.json';

const translationData = { en: en, mr: ma };
/**
 * Community WhatsApp CTA card
 *
 * Props:
 * - title: string
 * - description: string
 * - buttonText: string
 * - whatsappLink: string (URL)
 */
const HomeCommunityCallToAction = React.memo(({
  lang,
  title = 'Join Our Garbha Sanskar Community',
  description = '',
  buttonText = 'Join Group',
  whatsappLink = '#',
}) => {
  // Use lang prop if provided, else fallback to getLanguage
  const language = lang || getLanguage() || 'en';
  const t = (key) => {
    const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };

  const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
  const displayTitle = langKey === 'mr' ? t('community_title') : (title || t('community_title'));
  const displayDesc = langKey === 'mr' ? t('community_desc') : (description || t('community_desc'));
  const displayBtn = langKey === 'mr' ? t('community_btn') : (buttonText || t('community_btn'));
  const isValidWhatsAppLink = (link) => {
    if (!link) return false;
    if (typeof link !== 'string') return false;
    const trimmed = link.trim();
    if (!trimmed) return false;
    // Reject common placeholders
    const lower = trimmed.toLowerCase();
    if (trimmed === '#' || lower.includes('your-community-link') || lower === 'null') return false;
    // Any non-placeholder string returned from API should be considered valid.
    return true;
  };

  const handleClick = (event) => {
    if (!isValidWhatsAppLink(whatsappLink)) {
      event.preventDefault();
    }
  };

  return (
    <section className="community-cta">
      <div className="community-cta__container container-xl">
        <div className="community-cta__illustration">
          <img
            src={"https://res.cloudinary.com/dtuy184dc/image/upload/v1775113059/communit_e6t1ds.jpg"}
            alt="Community chat illustration"
            className="community-cta__illustration-image"
            loading="eager"
            decoding="sync"
          />
        </div>

        <div className="community-cta__content">
          {displayTitle && <h2 className="community-cta__title">{displayTitle}</h2>}

          {displayDesc && (
            <p className="community-cta__description">{displayDesc}</p>
          )}

          {displayBtn && isValidWhatsAppLink(whatsappLink) && (
            <div>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="community-cta__button"
              onClick={handleClick}
            >
              <i
                className="fab fa-whatsapp community-cta__whatsapp-icon"
                aria-hidden="true"
              ></i>
              {displayBtn}
            </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
});

HomeCommunityCallToAction.displayName = 'HomeCommunityCallToAction';

export default HomeCommunityCallToAction;

